import { css, styled } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, rgba } from "@similarweb/styles";
import { SimpleChipItem } from "@similarweb/ui-components";

export const ChipTrigger = styled(SimpleChipItem)<{
    isOpen: boolean;
    isDisabled?: boolean;
}>`
    margin: 0;
    background-color: ${colorsPalettes.carbon[400]};

    & .ChipItemText {
        color: ${colorsPalettes.carbon[0]};
    }

    ${SWReactIcons} svg path {
        fill: ${colorsPalettes.carbon[0]};
    }

    &:hover {
        background-color: ${colorsPalettes.carbon[500]};

        ${SWReactIcons} svg path {
            fill: ${colorsPalettes.carbon[0]};
        }
    }

    ${({ isOpen }) => isOpen && `box-shadow: inset 0 0 0 1px ${colorsPalettes.carbon[300]};`}

    ${({ isDisabled }) =>
        isDisabled &&
        css`
            cursor: not-allowed;
            background-color: ${rgba(colorsPalettes.carbon[200], 0.2)};

            & .ChipItemText {
                color: ${colorsPalettes.carbon[250]};
            }

            ${SWReactIcons} svg path {
                fill: ${colorsPalettes.carbon[250]};
            }

            &:hover {
                background-color: ${rgba(colorsPalettes.carbon[200], 0.2)};

                ${SWReactIcons} svg path {
                    fill: ${colorsPalettes.carbon[250]};
                }
            }
        `}
`;
